import { TListingFetchReason, TRESPONSE_MACHINE_SERVICE_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TMachineServiceState = {
  machineServiceListingInfo: {
    res: TRESPONSE_MACHINE_SERVICE_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  machineServiceListingPagination: TUserPaginationOption;
};

export const TMachineServiceInfoActionType = {
  GetMachineServiceList: 'GET_MACHINE_SERVICE_LIST' as const,
  GetMachineServiceListSuccess: 'GET_MACHINE_SERVICE_LIST_SUCCESS' as const,
  GetMachineServiceListFailure: 'GET_MACHINE_SERVICE_LIST_FAILURE' as const,
  SetMachineServiceListPagination: 'SET_MACHINE_SERVICE_LIST_PAGINATION' as const,
  UpdateMachineServiceTask: 'UPDATE_MACHINE_SERVICE_TASK' as const,
  UpdateMachineServiceTaskSuccess: 'UPDATE_MACHINE_SERVICE_TASK_SUCCESS' as const,
  UpdateMachineServiceTaskFailure: 'UPDATE_MACHINE_SERVICE_TASK_FAILURE' as const,
};
